<template lang="pug">
#modal-visualizar-camadas-vinculadas
    el-dialog(
        width='40%',
        title='Camadas vinculadas',
        :visible.sync='mostrar',
        :close-on-click-modal='false',
        :before-close='fechar'
    )
        main
            h3.mb-3 Empresa: {{ empresa.nomeEmpresa }}
            h3 Camadas:
            ul(v-loading='buscandoCamadas')
                li(v-for='camada in camadasVinculadas') {{ camada.nome }}

        footer(slot='footer')
            el-button(size='mini', @click='fechar') Voltar
</template>

<script>
import { CamadasService } from '@/services/CamadasService';

export default {
    name: 'ModalVisualizarCamadasVinculadas',
    props: {
        mostrar: {
            type: Boolean,
            required: true
        },
        empresa: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            camadasVinculadas: [],
            buscandoCamadas: false
        };
    },

    watch: {
        mostrar() {
            if (this.mostrar) {
                this.buscarCamadas();
            }
        }
    },

    methods: {
        async buscarCamadas() {
            this.buscandoCamadas = true;

            const { data } = await CamadasService.buscarCamadasPorEmpresa(
                this.empresa.idEmpresa
            );
            this.camadasVinculadas = data;
            this.buscandoCamadas = false;
        },

        fechar() {
            this.camadasVinculadas = [];
            this.$emit('fechar');
        }
    }
};
</script>
